import React from 'react';
import PropTypes from 'prop-types';
import IconBase from 'react-icon-base';
import theme from '../../themes';

const viewBoxWidth = 230;
const viewBoxHeight = 240;

const LogoIcon = ({ textColor, ...otherProps }) => (
  <IconBase
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    width="100%"
    height="auto"
    {...otherProps}
  >
    <g xmlns="http://www.w3.org/2000/svg">
      <ellipse fill={textColor} stroke={textColor} strokeWidth="11" strokeMiterlimit="10" cx="115" cy="119.6" rx="109" ry="113.607" />
      <g>
        <path fill="currentColor" d="M68.409,127.146c-1.451,0-2.814-0.564-3.841-1.59l-14.702-14.703c-1.025-1.026-1.591-2.39-1.591-3.841    c0-1.45,0.565-2.813,1.591-3.841c1.026-1.024,2.391-1.59,3.842-1.59s2.814,0.565,3.841,1.59l14.7,14.705    c1.027,1.026,1.593,2.389,1.592,3.84c0,1.451-0.564,2.814-1.592,3.84C71.223,126.582,69.859,127.146,68.409,127.146    L68.409,127.146z" />
        <path fill="currentColor" d="M154.139,105.83c-2.995,0-5.432-2.437-5.432-5.433V67.444c0-2.994,2.437-5.432,5.432-5.432    c2.994,0,5.431,2.438,5.431,5.432v32.953C159.569,103.394,157.133,105.83,154.139,105.83L154.139,105.83z" />
        <path fill="currentColor" d="M131.81,95.704c-2.996,0-5.433-2.438-5.433-5.436V45.734c0-2.994,2.437-5.432,5.433-5.432    c2.995,0,5.432,2.438,5.432,5.432v44.534C137.241,93.266,134.805,95.704,131.81,95.704L131.81,95.704z" />
        <path fill="currentColor" d="M109.479,95.048c-2.995,0-5.431-2.437-5.431-5.432V38.128c0-2.994,2.436-5.431,5.431-5.431    c2.996,0,5.433,2.437,5.433,5.431v51.488C114.911,92.611,112.475,95.048,109.479,95.048L109.479,95.048z" />
        <path fill="currentColor" d="M87.265,105.824c-2.994,0.063-5.481-2.321-5.545-5.316l-0.941-44.526    c-0.063-2.994,2.321-5.482,5.315-5.545c2.994-0.063,5.482,2.321,5.545,5.315l0.942,44.526    C92.644,103.273,90.26,105.761,87.265,105.824L87.265,105.824z" />
        <path fill="currentColor" d="M119.563,206.502c-8.107,0-17.798-6.24-25.293-16.285c-6.566-8.799-14.695-24.637-16.135-50.117    c-0.515-9.104,2.014-16.717,7.516-22.634c11.608-12.484,31.681-13.172,33.931-13.209c2.23,0.038,22.29,0.728,33.895,13.209    c5.501,5.917,8.028,13.53,7.516,22.634c-1.441,25.484-9.569,41.32-16.134,50.117C137.363,200.262,127.671,206.502,119.563,206.502    L119.563,206.502z M119.539,110.637c-6.578,0.14-19.806,2.434-27.652,10.151c-4.893,4.814-7.054,11.025-6.605,18.988    c2.433,42.984,25.198,60.35,34.281,60.35c9.085,0,31.854-17.365,34.288-60.35c0.446-7.967-1.715-14.178-6.609-18.988    c-7.85-7.717-21.077-10.011-27.655-10.151h-0.012H119.539L119.539,110.637z" />
        <g>
          <path fill="currentColor" d="M81.719,146.799c0.205,0.078,14.793,6.27,36.887,6.273c11.043,0.002,23.962-1.553,37.839-6.205     c1.221-0.41,1.848-1.65,1.402-2.768c-0.446-1.119-1.798-1.697-3.017-1.287c-13.31,4.461-25.659,5.941-36.225,5.945     c-10.562,0-19.338-1.488-25.45-2.965c-3.057-0.744-5.445-1.48-7.059-2.027c-0.809-0.273-1.42-0.502-1.825-0.656l-0.447-0.18     l-0.104-0.041l-0.021-0.008c-1.179-0.502-2.578-0.031-3.124,1.051C80.027,145.016,80.541,146.295,81.719,146.799z" />
        </g>
        <rect x="118.387" y="109.046" fill="currentColor" width="2.354" height="41.37" />
        <path fill="currentColor" d="M124.074,130.631c0,6.941-2.019,12.574-4.511,12.574c-2.491,0-4.51-5.633-4.51-12.574    c0-6.945,2.019-12.574,4.51-12.574C122.056,118.057,124.074,123.686,124.074,130.631z" />
      </g>
    </g>
  </IconBase>
);

LogoIcon.propTypes = {
  textColor: PropTypes.string,
};

LogoIcon.defaultProps = {
  textColor: theme.colors.black,
};

export default LogoIcon;



// WEBPACK FOOTER //
// ./src/app/components/logo/icon.js